export default __webpack_public_path__ + "static/media/instagram.22bda4c2.svg";